import React, { useState } from "react";

/**
 * Shared helpers for the showcase section files (icons, the surface Stage, and
 * the generic stateful-dialog demo). Section files live in this folder, one per
 * SHOWCASE_GROUP, each exporting its registry entries (render + co-located
 * `code`). componentRegistry.jsx just concatenates them.
 */

// Renders a child inside a .surface-* scope with that surface's background, so a
// component can be reviewed in both contexts.
export const Stage = ({ surface = "manager", width, children }) => (
  <div
    className={`surface-${surface} theme-groupardy`}
    style={{ background: "var(--surface-bg)", color: "var(--on-surface)", padding: 18, borderRadius: 10, width: width || "auto" }}
  >
    {children}
  </div>
);

const Ic = (d, fill = false) => () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill={fill ? "currentColor" : "none"} stroke={fill ? "none" : "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{d}</svg>
);
export const SearchIcon = Ic(<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>);
export const PlusIcon = Ic(<path d="M12 5v14M5 12h14" />);
export const PlayIcon = Ic(<path d="M7 4.5v15l13-7.5z" />, true);
export const GridIcon = Ic(<><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></>);
export const ListIcon = Ic(<><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></>);
export const SparkleIcon = Ic(<path d="M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" />, true);

export const demoTriggerBtn = { font: "inherit", fontSize: 13, fontWeight: 600, padding: "8px 14px", borderRadius: 8, border: "1px solid var(--surface-border,#e2e8f0)", background: "var(--accent,#2ec4b6)", color: "var(--accent-on,#fff)", cursor: "pointer" };

// Generic "click to open a dialog" harness for modal/toast demos.
export const ConfirmDemo = ({ trigger, render }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button style={demoTriggerBtn} onClick={() => setOpen(true)}>{trigger}</button>
      {render(open, () => setOpen(false))}
    </>
  );
};
